import { createPortal } from 'react-dom';

interface AlertModalProps {
    isOpen: boolean;
    title: string;
    message: string;
    confirmLabel?: string;
    onClose: () => void;
    secondaryAction?: {
        label: string;
        onClick: () => void;
    };
}

export function AlertModal({
    isOpen,
    title,
    message,
    confirmLabel = 'OK',
    onClose,
    secondaryAction,
}: AlertModalProps) {
    if (!isOpen) return null;

    return createPortal(
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
            <div
                className="absolute inset-0 bg-black/60 backdrop-blur-sm transition-opacity"
            />
            <div className="relative bg-white dark:bg-[#00172D] rounded-[2.5rem] shadow-2xl w-full max-w-sm p-8 transform transition-all scale-100 animate-in fade-in zoom-in-95 duration-200 border border-transparent dark:border-white/5">
                <div className="text-center mb-8 mt-2">
                    <h3 className="text-2xl font-black text-gray-900 dark:text-white mb-3">{title}</h3>
                    <p className="text-gray-500 dark:text-gray-400 font-medium leading-relaxed">
                        {message}
                    </p>
                </div>

                <div className="flex flex-col gap-3">
                    {secondaryAction && (
                        <button
                            onClick={() => { onClose(); secondaryAction.onClick(); }}
                            className="w-full py-4 px-4 rounded-2xl font-bold text-white shadow-lg transition-all active:scale-95 bg-blue-600 hover:bg-blue-700 dark:bg-blue-400 shadow-blue-500/20 dark:shadow-none"
                        >
                            {secondaryAction.label}
                        </button>
                    )}
                    <button
                        onClick={onClose}
                        className={`w-full py-4 px-4 rounded-2xl font-bold transition-all active:scale-95 ${secondaryAction
                                ? 'text-gray-600 dark:text-gray-300 bg-gray-100 dark:bg-white/10 hover:bg-gray-200 dark:hover:bg-white/15'
                                : 'text-white shadow-lg bg-blue-600 hover:bg-blue-700 dark:bg-blue-400 shadow-blue-500/20 dark:shadow-none'
                            }`}
                    >
                        {confirmLabel}
                    </button>
                </div>
            </div>
        </div>,
        document.body
    );
}
